



//const  ApiPath = "https://tom9.myexamo.com/tqwebsite";
const  ApiPath = "https://tom9.myexamo.com/tqaiwebsite";

//  const  ApiPath = "http://localhost:8080";
// const ApiPath = "http://localhost:8080/tqaiwebsite";

export default ApiPath;